import React from "react";
import "./styles.css";

interface Iprops {
  hoverCategories: any;
  setHoverCategories: any;
}

const CategoriesSubMenu: React.FC<Iprops> = ({
  setHoverCategories,
  hoverCategories,
}) => {
  return (
    <div
      onMouseOver={() => setHoverCategories(true)}
      onMouseLeave={() => setHoverCategories(false)}
      className="CategoriesSubMenu"
    >
      <div className="CategoriesSubMenu_relative">
        <div className="CategoriesSubMenu_relative_list" >
          <div className="categoriSub">
            <h1>VITAMINAS Y MINERALES</h1>
            <p>Coenzimas</p>
            <p>Multivitaminas</p>
            <p>Multivitaminas</p>
            <p>Multivitaminas</p>
            <p>Multivitaminas</p>
            <p>Multivitaminas</p>
            <p>Coenzimas</p>
          </div>
          <div className="categoriSub">
            <h1>PROTEINAS</h1>
            <p>Proteina vegana</p>
            <p>Proteina vegana</p>
            <p>Proteina vegana</p>
            <p>Proteina vegana</p>
            <p>Proteina vegana</p>
            <p>Proteina vegana</p>
          </div>
          <div className="categoriSub">
            <h1>BARRAS DE PROTEINA</h1>
            <p>Barra 12gr chocolate</p>
            <p>Barra 12gr chocolate</p>
            <p>Barra 12gr chocolate</p>
            <p>Barra 12gr chocolate</p>
            <p>Barra 12gr chocolate</p>
            <p>Barra 12gr chocolate</p>
          </div>
          <div className="categoriSub">
            <h1>PROTEINAS</h1>
            <p>Proteina vegana</p>
            <p>Proteina vegana</p>
            <p>Proteina vegana</p>
            <p>Proteina vegana</p>
            <p>Proteina vegana</p>
            <p>Proteina vegana</p>
          </div>
        </div>

        <div className="color__second"></div>
      </div>
    </div>
  );
};

export default CategoriesSubMenu;
